<template>
  <div id="placeInfo" v-cloak>
    <div class="LogoBorder">
      <img :src="logoUrl" alt="">
      <div>|</div>
      <div>弘成慧考平台</div>
    </div>
    <div class="Main" v-if="checkSignFlag && isLoading">
      <div class="list">
        <span class="icon"></span>
        <span class="title">违纪图片</span>
      </div>
      <div class="list">
        <span class="label">姓名</span>
        <span class="label">：</span>
        <p class="text">{{stuInfo.realName}}</p>
      </div>
      <div class="list">
        <span class="label">证件号</span>
        <span class="label">：</span>
        <p class="text">{{stuInfo.cardNo}}</p>
      </div>
      <!-- <div class="list">
        <span class="label">违纪描述</span>
        <span class="label">：</span>
        <p class="text">{{msg}}</p>
      </div> -->
      <div class="list">
        <span class="label">上传图片</span>
        <span class="label">：</span>
        <van-form @submit="onSubmit">
        <van-field name="uploader">
          <template #input>
            <van-uploader v-model="imgList" style="display: inline-block;" />
          </template>
        </van-field>
        <div style="margin: 16px; width: 4rem;">
          <van-button round block type="info" native-type="submit">确认上传</van-button>
        </div>
      </van-form>
      </div>
    </div>
    <div class="Main" v-if="!checkSignFlag && isLoading">
      <div class="list">
        <p class="text">该功能暂时无法使用。</p>
      </div>
    </div>
    <div class="SwiperBottom"></div>
  </div>
</template>
<script>
  import { Toast } from "vant";
  export default {
    data() {
      return {
        logoUrl: '',
        imgList: [],
        checkSignFlag: false,
        stuInfo: {},
        msg: '',
        isLoading: false,
      }
    },
    created() {
      this.checkSignFN();
    },
    methods: {
      async onSubmit(values) {
        if (values.uploader.length == 0) {
          Toast("请上传违纪图片！");
          return;
        }
        let imgList = [];
        values.uploader.map(e=>{
          let item = {};
          if (e.content) {
            e.url = e.content;
            item = {url: e.url.split(",")[1]};
          } else {
            item = e;
          }
          imgList.push(item);
        })
        let params = {
          tenant: this.$route.query.tenant,
          studentCourseId: this.stuInfo.studentCourseId,
          imgList: JSON.stringify(imgList)
        }
        const { code } = await this.$api.system.uploadUnusualImg(params);
        if (code === 1) {
          Toast("提交成功！");
        }
      },

      // Logo + 验签
      async checkSignFN() {
        const { tenant, serialNumber, msg, timestamp, st} = this.$route.query;
        this.msg = msg;
        const res = await this.$api.system.getSystemNameFN({ tenant });
        this.logoUrl = res.data.isUsedLogo == 1 ? res.data.logoUrl ? res.data.logoUrl : require("@/assets/img/customDefault.png") : require("@/assets/img/customDefault.png");
        const { code } = await this.$api.system.checkSign({tenant, serialNumber, timestamp, st});
        this.checkSignFlag = code === 0 ? false: true;
        this.isLoading = true;
      },

      // 获取
      async getInfo() {
        const {tenant, serialNumber, cardNumber, courseName} = this.$route.query;
        const { code, data } = await this.$api.system.getUnusualInfo({tenant, serialNumber, cardNumber, courseName});
        if (code === 1) {
          this.stuInfo = data;
          this.imgList = data.imgList;
        }
      },
    },
    watch: {
      checkSignFlag: async function(val) {
        if (val) {
          await this.getInfo();
        } 
      }
    }
  }
</script>

<style scoped lang="less">
[v-clock] {
  display: none
}
#placeInfo {
  width: 100%;
  height: auto;
  min-height: 100%;
  background: rgba(255, 245, 248, 1);
  background: url("../../assets/img/placeInfo_bg.png") no-repeat;
  background-size: 100% 3.2rem;
  padding: 0 .38rem;
  overflow: hidden;
  box-sizing: border-box;
  .LogoBorder {
    width: 100%;
    height: 1.5rem;
    padding-top: .5rem;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 0.32rem;
    &>img {
      width: auto;
      height: .8rem;
    }
    &>div {
      color: #FFF;
      line-height: .8rem;
      margin: 0 .2rem;
      font-size: .48rem;
      font-display: optional;
      font-weight: 500;
    }
    &>div:first-of-type {
      color: rgba(255, 255, 255, 0.3);
    }
  }
  .Main {
    width: 100%;
    background: #FFF;
    border-radius: .2rem;
    padding-top: .5rem;
    padding-bottom: .5rem;
    font-display: optional;
    font-display: block;
    box-shadow: #737780 0 0 .1rem;
    font-size: .38rem;
    .list {
      padding: 0 .4rem;
      box-sizing: border-box;
      padding-bottom: .4rem;
      display: flex;
      .label:first-child {
        color: #737780;
        display: inline-block;
        min-width: 1.6rem;
        line-height: .5rem;
        text-align: justify;
        text-align-last: justify;
        font-size: .38rem;
      }
      .text {
        word-wrap: break-word;
        word-break: break-all;
        display: inline-block;
        color: #2D2F33;
        line-height: .5rem;
        max-width: 6.5rem;
        height: auto;
      }
      &>.title {
        font-size: .48rem; 
        display: inline-block;
        height: .48rem;
        line-height: .48rem;
      }
      &>.icon {
        width: .1rem;
        height: .48rem;
        background: #006AFF;
        display: inline-block;
        margin-right: .1rem;
        border-radius: .05rem;
      }
    }
  }
  .SwiperBottom {
    width: 95%;
    background: #FFF;
    height: .20rem;
    margin: .05rem auto;
    border-radius: 0 0 .2rem .2rem;
    box-shadow: 0 .2rem .1rem -0.2rem #737780;
  }

  .van_form_label {
    color: #737780;
    display: inline-block;
    min-width: 2rem;
    line-height: .5rem;
    text-align: justify;
    text-align-last: justify;
    font-size: .38rem;
    margin-right: 0;
  }
}
</style>